export const BUILD_VERSION = {
  "buildNumber": 115,
  "buildDate": "2025_12_18",
  "version": "00115/2025_12_18"
};